<template>
    <div class="profile-about-blocks d-flex">

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{userData.actual_pets_count || 0}}</span>
                {{$store.getters.t('user_about_current')}} <br> {{$store.getters.t('user_about_wards')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{userData.total_pets_count || 0}}</span>
                {{$store.getters.t('user_about_total')}} <br> {{$store.getters.t('user_about_animals')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{userData.adopted_pets_count || 0}}</span> {{$store.getters.t('user_about_homed')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{ userData.actual_projects_count || 0 }}</span> {{$store.getters.t('user_about_projects')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">
                    {{+userData['donated_by_user']}} USD
                </span>

                {{$store.getters.t('user_about_funds')}} <br> {{$store.getters.t('user_about_sent')}}
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: ['userData'],
    name: "ProfileAboutBlocks",
    data(){
        return{
        }
    },

}
</script>

<style lang="scss" scoped>

</style>
